export const FETCH_SHIFTS = 'FETCH_SHIFTS';
export const FETCH_SHIFT = 'FETCH_SHIFT';
export const ADD_SHIFT = 'ADD_SHIFT';
export const UPDATE_SHIFT = 'UPDATE_SHIFT';
export const DELETE_SHIFT = 'DELETE_SHIFT';
